"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationType = void 0;
var NotificationType;
(function (NotificationType) {
    NotificationType["CART_ERROR"] = "cartError";
    NotificationType["EMPTY_CART"] = "emptyCart";
    NotificationType["INFO_CART"] = "infoCart";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
//# sourceMappingURL=NotificationPanelProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/panels/NotificationPanel/NotificationPanelProps.js
// module id = 452
// module chunks = 8